import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { KingspanDeviceFormController } from "./kingspan-device-form.controller"
import { LOCATION_SERVICE_NAME } from "../../../../services/location"
import { $SCOPE_SERVICE_NAME } from "../../../../services/system"
import { KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME } from "../service"

//#region Asset Imports

import './kingspan-device-form.scss'
import * as TEMPLATE from './kingspan-device-form.tpl.html'

//#endregion

export class KingspanDeviceFormComponent implements ng.IComponentOptions {
    controller = [$SCOPE_SERVICE_NAME, USER_SESSION_SERVICE_NAME, LOCATION_SERVICE_NAME, KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME, KingspanDeviceFormController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE
}